import script from "./SettingsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsModal.vue?vue&type=script&setup=true&lang=js"

import "./SettingsModal.vue?vue&type=style&index=0&id=25b50ccb&scoped=true&lang=css"
import "./SettingsModal.vue?vue&type=style&index=1&id=25b50ccb&lang=css"
import "./SettingsModal.vue?vue&type=style&index=2&id=25b50ccb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25b50ccb"]])

export default __exports__